import React from 'react'

const ProvisionalRateSheetFooter = () => (
    <div>
        * These provisional royalty statement rate calculation sheets are subject to change upon The MLC&apos;s
        completion of processing of corresponding usage files. The MLC will provide final royalty statement rate
        calculation sheets after such processing, which will supersede these provisional sheets and may contain
        different figures.
    </div>
)

export default ProvisionalRateSheetFooter
